<template>
  <v-container class="feature-container">
    <v-row class="justify-center align-center text-center ma-0">
    <v-col cols="12" sm="6" md="6" class="justify-center align-center text-center">
      <v-img
          class="white--text"
          aspect-ratio="2"
          src="@/assets/logo.png"
          contain
           @click="$router.push('/login')"
        >
        </v-img>
    </v-col>
    <v-col cols="12" sm="6" md="6" >
      <!-- <v-row align="center"> -->
      <v-col align="center" cols="12" lg="12" md="12" sm="12" xs="12">
        <h1>Privacy Policy</h1>
      </v-col>
    <!-- </v-row> -->

    <v-row align="center" justify="center" >
      <v-col  cols="12"  v-bind:style="{height:'60vh', overflow:'auto' }">
        
        <span style="text-align: left; float: left;font-size:16px;" v-html="`
        At DCM, we respect your privacy and are committed to protecting your personal data. This
Privacy Policy outlines how we collect, use, and share your information when you engage with
our services, including visiting our website or utilizing our business and legal .<br/><br/>
<span style='float: left;font-weight:bold;'>1. Who We Are</span><br><br>
          <span>&ensp;&ensp;&ensp;&ensp; Digital Corporate Management Co., Ltd. (DCM), is a part of Dej-Udom & Associates who
provides a broad range of corporate, legal, and digital solutions. We specialize in corporate and
legal advisory, business restructuring, compliance, and digital transformation to help clients
navigate modern business challenges</span><br><br>
         <span style='float: left;font-weight:bold;'>2. Personal Data We Collect</span><br><br>
          <span>&ensp; We may collect the following types of personal data: </span><br>
<ul>
  <li><span style='float: left;font-weight:bold;'>Personal Information:</span> Information such as your name, email address, contact details,
and any other data you provide when engaging with our services or communicating with
us.
</li>
  <li><span style='float: left;font-weight:bold;'>Location Data Usage:</span>Our app collects and uses your location data 
  <span style='float: left;font-weight:bold;'>only for
work-related check-in purposes</span>This ensures accurate attendance tracking by
verifying your location when you check in or check out of your workplace. For example,
when an employee checks in, the app records their location to confirm they are at the
designated worksite, ensuring compliance with company policies. We do not use your
location for any other purpose, and your data is securely processed following privacy
regulations</li>
  <li><span style='float: left;font-weight:bold;'>Information from Third Parties:</span>Data obtained from third-party services, such as
Google, when using single sign-on options, or from our professional partners and
affiliates.
</li>
</ul><br/><br/>

 <span style='float: left;font-weight:bold;'>3. How We Collect Your Data</span><br><br>
          <span>&ensp; We collect your personal data in the following ways:
</span><br>
<ul>
  <li><span style='float: left;font-weight:bold;'>Direct Interactions:</span> When you sign up for our services, communicate with us, attend
events, or participate in webinars and virtual meetings.
</li>
  <li><span style='float: left;font-weight:bold;'>Automated Technologies:</span>: Data collected through cookies or similar technologies when
you engage with our website
</li>
  <li><span style='float: left;font-weight:bold;'>Third-Party Sources: </span>Data from professional colleagues, organizations, or third-party
service providers that collaborate with DCM.
</li>
</ul><br/><br/>


<span style='float: left;font-weight:bold;'>4. How We Use Your Data</span><br><br>
          <span>&ensp; We use your personal data to:
</span><br>
<ul>
  <li>Provide, improve, and secure our services, ensuring a smooth experience across our
legal and business solutions.
</li>
  <li>Send email newsletters, updates, and other communications relevant to our services
and products.
</li>
  <li>Conduct statistical analysis for marketing and business development purposes.
</li>
 <li>Support digital transformation and management consulting, offering tailored legal and
corporate advisory services to clients
</li>
</ul><br/><br/>


 <span style='float: left;font-weight:bold;'>5. How We Share Your Data</span><br><br>
          <span>&ensp; We may share your data with:
</span><br>
<ul>
  <li><span style='float: left;font-weight:bold;'>Service Providers:</span>Third-party providers that support business functions, including
digital tools, consulting, and marketing services.
</li>
  <li><span style='float: left;font-weight:bold;'>Advertising Networks:</span>Partners that help display targeted advertisements across our
platforms.
</li>
  <li><span style='float: left;font-weight:bold;'>Legal Obligations:</span>Courts, law enforcement, or government authorities to comply with
legal requirements or protect the rights and safety of DCM and its clients.
</li>
</ul><br/><br/>


 <span style='float: left;font-weight:bold;'>6. Your Rights and Choices</span><br><br>
          <span>&ensp; You have the right to:
</span><br>
<ul>
  <li><span style='float: left;font-weight:bold;'>Access and Update:</span> : Review and update your personal data at any time.
</li>
  <li><span style='float: left;font-weight:bold;'>Opt-out:</span>Unsubscribe from email communications by following the instructions in our
emails or contacting us directly.
</li>
</ul><br/><br/>


<span style='float: left;font-weight:bold;'>7. Security of Your Data</span>
          <span>&ensp; We implement technical and administrative safeguards to protect your personal data from
unauthorized access or misuse. However, no online data transmission is completely secure, and
users provide information at their own risk.</span><br><br>

<span style='float: left;font-weight:bold;'>8. Changes to This Policy</span>
          <span>&ensp; We may update this Privacy Policy periodically. Any changes will be communicated directly or
posted on our website.</span><br><br>

<span style='float: left;font-weight:bold;'>9. Contact Information</span>
          <span>&ensp; For questions or concerns about this Privacy Policy or your personal data, please contact us at:</span><br><br>

          <span style='font-weight:bold;'>Digital Corporate Management Co., Ltd.</span><br>
          <span>Charn Issara Tower I, 2nd Fl.,</span><br>
         <span>942/69 Rama IV Road,</span><br>
          <span>Bangrak District, Bangkok 10500</span><br>
           <span>Tel: (66) 2233-0055</span><br>
            <span>Email: admin@dcm.co.th</span><br>
          `">
        </span>
      
      </v-col>
    </v-row>
    </v-col>
   

  

    <SuccessDialog
      :status="dialogAdd"
      :text_color="text_color"
      :title="title"
      :message="message"
    />
  <!-- </v-container> -->
</v-row>


    
  </v-container>
</template>

<script>
import { feature } from "../services/constants";
export default {
  name: "feature",
  data: () => ({
    width: 420,
    text_fontsize: 30,
  }),
  methods: {
    onClickMenu(link) {
      // console.log(link);
      this.$router.push(link).catch((err) => {});
    },
  },
  async beforeCreate() {
    this.$store.state.page_reload = false;

    // alert(localStorage.getItem("language"))
    // console.log("language login : " + localStorage.getItem(feature.LANGUAGE))
  },
  async mounted() {
    this.$hideLoader();

  },
};
</script>

<style>
@media (min-width: 960px) {
  .feature-container {
    margin-top: 3rem
  }
}
</style>
